<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script setup>
import { useCssVar, useResizeObserver, useDebounceFn } from "@vueuse/core";
import { onBeforeUnmount, ref, watch } from "vue";

const SCROLL_THRESHOLD = 55;

const el = ref(null);
const shouldResize = ref(true);

const actionButtonsHeight = useCssVar(
    "--bam-action-buttons-height",
    ref(document.documentElement)
);

const { stop } = useResizeObserver(el, (entries) => {
    if (!shouldResize.value) {
        return;
    }
    const entry = entries[0];
    const { blockSize: height } = entry.borderBoxSize[0];
    actionButtonsHeight.value = `${height}px`;
});

watch(
    [actionButtonsHeight],
    ([height]) => {
        actionButtonsHeight.value = height;
    },
    { immediate: true }
);

onBeforeUnmount(() => {
    stop();
});
</script>

<template>
    <div
        class="action-buttons"
        ref="el"
        @mouseover="shouldResize = false"
        @mouseleave="
            useDebounceFn(() => {
                shouldResize = true;
            }, 1000)
        "
    >
        <slot />
    </div>
</template>
